export function deepMerge<T>(target: Partial<T>, source: Partial<T>): T {
    const result: any = { ...target };
    
    for (const key in source) {
      if (source[key] instanceof Object && key in target && target[key] instanceof Object) {
        if (Array.isArray(source[key]) && Array.isArray(target[key])) {
          result[key] = (source[key] as any[]).map((item, index) => {
            if (item instanceof Object && index < (target[key] as any[]).length && (target[key] as any[])[index] instanceof Object) {
              return deepMerge((target[key] as any[])[index], item);
            }
            return item;
          });
        } else {
          result[key] = deepMerge(target[key] as any, source[key] as any);
        }
      } else {
        result[key] = source[key];
      }
    }
    
    return result as T;
}